var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 8.08994C19.2079 6.89716 18.947 5.71329 18.4083 4.64828C18.0428 4.21128 17.5356 3.91637 16.975 3.81494C14.6563 3.60455 12.3279 3.51831 10 3.55661C7.68054 3.51658 5.36059 3.60003 3.05 3.80661C2.59319 3.88971 2.17043 4.10398 1.83334 4.42328C1.08334 5.11494 1 6.29828 0.916669 7.29828C0.795762 9.09625 0.795762 10.9003 0.916669 12.6983C0.940777 13.2611 1.02458 13.8198 1.16667 14.3649C1.26715 14.7858 1.47044 15.1752 1.75834 15.4983C2.09773 15.8345 2.53032 16.061 3 16.1483C4.7966 16.37 6.60685 16.4619 8.41667 16.4233C11.3333 16.4649 13.8917 16.4233 16.9167 16.1899C17.3979 16.108 17.8427 15.8812 18.1917 15.5399C18.425 15.3065 18.5992 15.0209 18.7 14.7066C18.998 13.7921 19.1444 12.835 19.1333 11.8733C19.1667 11.4066 19.1667 8.58994 19.1667 8.08994ZM8.11667 12.3733V7.21494L13.05 9.80661C11.6667 10.5733 9.84167 11.4399 8.11667 12.3733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.17c504dd0ea911577ca35e95cf98df1c.svg";
export { ForwardRef as ReactComponent };